// extracted by mini-css-extract-plugin
export default {"pricingContainer":"styles_pricingContainer__603zI","pricingContent":"styles_pricingContent__OEDc-","price":"styles_price__8EHkv","description":"styles_description__NZ1ED"};